import React, {
  useCallback,
  useEffect,
  useContext,
  useRef,
  useState,
  useMemo,
} from "react";
import {
  VYLABS_BASE_URL,
  GET_TENANT_DETAILS,
  METRICS_RECRUITER_DASHBOARD_SUMMARY,
  METRICS_RECENT_ACTIVITY,
  METRICS_CANDIDATE_WORKSPACE,
  METRICS_RECRUITER_DASHBOARD_FOLLOWUPS,
  NOTIFICATIONS_GET,
  WEB_SOCKET_URL,
  GET_CANDIDATE_BY_ID,
  SEARC_JOBS,
  JOBS_LIST,
  UPDATE_CANDIDATE_DETAILS,
  DELETE_CANDIDATE_DETAILS,
  GET_SAVED_VIEWS,
  CREATE_SAVED_VIEWS,
  METRICS_JOB_WORKSPACE,
  DELETE_SAVED_VIEWS,
  UPDATE_SAVED_VIEWS,
} from "../../../helper/url_helper";
import { get, post, deleteRequest, patch } from "../../../helper/Api_helper";
import { TENANT_CORE_API_KEY } from "../../../Tenant-Config/TenantConfig.js";
import DashboardCard from "../../../Common/Card/DashboardCard";
import { DynamicContext } from "../../../Context/DynamicContext";
import Table from "../../../Common/Table/Table";
import { getStageColor } from "../../../Common/constants/stageColors";
import "./MemberDashboard.css";
import { useNavigate } from "react-router-dom";
import notificationIcon from "../../../Assets/Images/notifications-read-light.svg";
import notificationDarkIcon from "../../../Assets/Images/notifications-read-dark.svg";
import phoneIcon from "../../../Assets/Images/member-dashboard-phone.svg";
import mailIcon from "../../../Assets/Images/member-dashboard-mail.svg";
import viewCandidateIcon from "../../../Assets/Images/member-dashboard-view-candidate.svg";
import NotificationPopup from "../../../Common/Notification-Popup/NotificationPopup.js";
import { StandardPopup } from "../../../Common/PopupStyles/PopupComponent";
import Button from "../../../Common/Button/Button";
import TextInput from "../../../Common/TextInput/TextInput";
import ToggleSwitcher from "../../../Common/Toggle-Switcher/ToggleSwitcher";
import SidePopup from "../../../Common/SidePopup/SidePopup.js";
import { ConfirmationPopup } from "../../../Common/PopupStyles/PopupComponent";
import CandidateDetailsContainer from "../../../Common/Candidate-Details-Container/CandidateDetailsContainer.js";
import CustomTooltip from "../../../Common/Tooltip/Tooltip";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar";
import {
  applyEllipsis,
  toCamelCase,
  filterPayload,
  toCapitalize,
} from "../../../Common/Common-Function/CommonFunctions";
import editIcon from "../../../Assets/Images/edit-track-icon.svg";
import deleteIcon from "../../../Assets/Images/delete-red-icon.png";
import ReachOutIcon from "../../../Assets/Images/reach-out-icon.svg";
import SimpleCepheaChat from "../../../Common/Simple-Search-Box/SimpleSearchBox.js";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations.js";
import MonthFilter from "../../../Common/Month-Filter/MonthFilter.js";
import DynamicAutocomplete from "../../../Common/AutoSuggestion/DynamicAutocomplete.js";
import HelloIcon from "../../../Assets/Images/Hello-Icon.svg";
import SimpleSearchDarkIcon from "../../../Assets/Images/Candidates Search Icon Dark.svg";
import NoActivityDark from "../../../Assets/Images/no-activity-dark.svg";
import NoActivityLight from "../../../Assets/Images/no-activity-light.svg";
import NoCandidatesDark from "../../../Assets/Images/no-candidates-dark.svg";
import NoCandidatesLight from "../../../Assets/Images/no-candidates-light.svg";
import NoFollowupDark from "../../../Assets/Images/no-followup-dark.svg";
import NoFollowupLight from "../../../Assets/Images/no-followup-light.svg";
import moment from "moment";
import TrialSnackbar from "../FreeTrialToast.js";
import DynamicCallStage from "../../../Common/DynamicCallStage/DynamicCallStage.jsx";
import { fetchCallStages } from "../../../Common/DynamicCallStage/DynamicCallStageMapping.js";
import sortAscDarkIcon from "../../../Assets/Images/sort-asc-dark.svg";
import sortAscLightIcon from "../../../Assets/Images/sort-asc-light.svg";
import sortDscDarkIcon from "../../../Assets/Images/sort-des-dark.svg";
import sortDscLightIcon from "../../../Assets/Images/sort-des-light.svg";
import DynamicSelectInput from "../../../Common/Select-Input/SelectInput.js";
import CriticalIcon from "../../../Assets/Images/critical-icon.svg";
import HighIcon from "../../../Assets/Images/high-icon.svg";
import LowIcon from "../../../Assets/Images/low-icon.svg";
import MediumIcon from "../../../Assets/Images/medium-icon.svg";
import OptionsData from "../../../Assets/Json/StaticOptions.json";
import { CalendarDays } from "lucide-react";
import SettingsDarkIcon from "../../../Assets/Images/settings-dark.svg";
import SettingsIcon from "../../../Assets/Images/mingcute_settings-1-line.svg";

const PRIORITY_ICON_MAP = { CriticalIcon, HighIcon, MediumIcon, LowIcon };

const MEMBER_DASHBOARD_SAVED_VIEW_SCOPE = "member_dashboard";
const JOBS_PAGE_SIZE = 10;

const getJobsPageFromOffset = (offsetValue = 0) =>
  Math.floor(Number(offsetValue || 0) / JOBS_PAGE_SIZE) + 1;

const getCustomizeColumnsFromTableColumns = (columns = []) =>
  columns.reduce((acc, column) => {
    acc[column.columnKey] =
      typeof column.name === "string" ? column.name : column.columnKey;
    return acc;
  }, {});

const getSavedColumnKeys = (savedColumns = [], availableKeys = []) =>
  savedColumns
    .map((column) => column?.system_key || column?.systemKey || column)
    .filter((columnKey) => availableKeys.includes(columnKey));

const getSelectedCustomizeColumns = (columnsForCustomize, selectedKeys) =>
  Object.entries(columnsForCustomize)
    .filter(([key]) => selectedKeys.includes(key))
    .map(([systemKey, name]) => ({
      system_key: systemKey,
      name,
    }));

    function ColumnCustomizeDropdown({
      buttonRef,
      columns,
      draftColumns,
      dropdownRef,
      idPrefix,
      isDarkMode,
      isOpen,
      hasSavedView,
      onCreateSaveView,
      onSelectAll,
      onSelectNone,
      onToggleColumn,
      onToggleDropdown,
      onUpdateSaveView,
    }) {
      return (
        <div className="filter-container admin-dashboard-column-filter-container">
          <button
            className="column-visibility-btn"
            onClick={onToggleDropdown}
            ref={buttonRef}
          >
            <img
              src={isDarkMode ? SettingsDarkIcon : SettingsIcon}
              alt="SettingsIcon"
              className="speedDial-popup-icon"
            />
            Customize
          </button>
          {isOpen && (
            <div className="column-visibility-dropdown" ref={dropdownRef}>
              <div className="column-checkbox-item">
                <button
                  onClick={onSelectAll}
                  className="view-button"
                  style={{
                    height: "36px",
                    width: "100px",
                    background: "#6860ee",
                    borderRadius: "8px",
                    cursor: "pointer",
                    padding: "8px 14px",
                    fontFamily: "Satoshi",
                    fontWeight: 600,
                    fontSize: "14px",
                    outline: "none",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    gap: 10,
                    border: "1px solid #6860EE",
                    color: "#FFFFFF",
                  }}
                >
                  Select All
                </button>
                <button
                  onClick={onSelectNone}
                  className="view-button"
                  style={{
                    height: "36px",
                    width: "100px",
                    background: "var(--body__background)",
                    borderRadius: "8px",
                    cursor: "pointer",
                    padding: "8px 14px",
                    fontFamily: "Satoshi",
                    fontWeight: 600,
                    fontSize: "14px",
                    outline: "none",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    gap: 10,
                    border: "1px solid #6860EE",
                    color: "#6860EE",
                  }}
                >
                  Clear All
                </button>
              </div>
              {Object.entries(columns).map(([key, name]) => (
                <div key={key} className="column-checkbox-item">
                  <input
                    type="checkbox"
                    id={`${idPrefix}-${key}`}
                    checked={draftColumns.includes(key)}
                    onChange={() => onToggleColumn(key)}
                  />
                  <label htmlFor={`${idPrefix}-${key}`}>{toCapitalize(name)}</label>
                </div>
              ))}
              <div
                style={{
                  marginTop: "5px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {hasSavedView ? (
                  <Button label="Update saved view" event={onUpdateSaveView} />
                ) : (
                  <Button label="Create saved view" event={onCreateSaveView} />
                )}
              </div>
            </div>
          )}
        </div>
      );
    }

function MemberDashboard() {
  const {
    isDarkMode,
    userDetails,
    tenantDetails,
    setTenantDetails,
    notificationsState,
    setNotificationsState,
    AdminAccess,
    subscriptionDetails,
    isVendorFeatureEnabled,
  } = useContext(DynamicContext);
  
  const { priority = [], assignedOrTracked = [] } = OptionsData?.StaticOptions || {};
  const [showAddMemberBanner, setShowAddMemberBanner] = useState(false);
  const [showTrialSnackbar, setShowTrialSnackbar] = useState(false);
  const [daysLeftInTrial, setDaysLeftInTrial] = useState(0);
  const hasShownSnackbarRef = useRef(false);
  const [tenantFetchError, setTenantFetchError] = useState(false);
  const [dashboardSummary, setDashboardSummary] = useState({});
  const [selectedCandidateWorkspaceColumn, setSelectedCandidateWorkspaceColumn] =
  useState("");
  const [candidateWorkspace, setCandidateWorkspace] = useState([]);
  const [jobWorkspace, setJobWorkspace] = useState([]);
  const [jobWorkspaceLoader, setJobWorkspaceLoader] = useState(true);
  const [jobWorkspaceTotal, setJobWorkspaceTotal] = useState(0);
  const [jobWorkspaceCurrentPage, setJobWorkspaceCurrentPage] = useState(1);
  const [jobWorkspaceSort, setJobWorkspaceSort] = useState({
    sortBy: "",
    sortOrder: "asc",
  });
  const [selectedJobWorkspaceColumn, setSelectedJobWorkspaceColumn] = useState("");
  const [selectedTagBasedFilter, setSelectedTagBasedFilter] = useState("");
  const [candidateWorkspaceLoader, setCandidateWorkspaceLoader] =
    useState(true);
  const [followups, setFollowups] = useState({
    today: [],
    overdue: [],
    tomorrow: [],
  });
  const [followUpsLoader, setFollowUpsLoader] = useState(true);
  const [recentActivity, setRecentActivity] = useState([]);
  const [candidateCurrentPage, setCandidateCurrentPage] = useState(1);
  const [candidateTotalRows, setCandidateTotalRows] = useState(0);
  const [candidateWorkspaceSort, setCandidateWorkspaceSort] = useState({
    sortBy: "",
    sortOrder: "asc",
  });
  const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);
  const [filters, setFilters] = useState({
    stage: "",
    time: "today",
    jobId: "",
    jobTitle: "",
    search: "",
  });
  const [savedViews, setSavedViews] = useState([]);
  const [selectedSavedViewId, setSelectedSavedViewId] = useState(null);
  const [isLoadingSavedViews, setIsLoadingSavedViews] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [savedViewName, setSavedViewName] = useState("");
  const [savedViewIsDefault, setSavedViewIsDefault] = useState(false);
  const [isCreatingSavedView, setIsCreatingSavedView] = useState(false);
  const [savedViewPendingDelete, setSavedViewPendingDelete] = useState(null);
  const [isSavedViewDeleteDialogOpen, setIsSavedViewDeleteDialogOpen] =
    useState(false);
  const [isDeletingSavedView, setIsDeletingSavedView] = useState(false);
  const [recentActivityOffset, setRecentActivityOffset] = useState(0);
  const [recentActivityHasMore, setRecentActivityHasMore] = useState(true);
  const [recentActivityLoading, setRecentActivityLoading] = useState(false);
  const [recentActivityLoader, setRecentActivityLoader] = useState(true);
  const [isCandidatePopupOpen, setIsCandidatePopupOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [candidateLoading, setCandidateLoading] = useState(false);
  const [jobListOptions, setJobListOptions] = useState([]);
  const [jobOptionLoading, setJobOptionLoading] = useState(false);
  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [isDeleteCandidatePopupOpen, setIsDeleteCandidatePopupOpen] =
    useState(false);
  const [callStageMap, setCallStageMap] = useState({});
  const [customizeDropdownOpen, setCustomizeDropdownOpen] = useState(false);
  const [savedJobWorkspaceColumns, setSavedJobWorkspaceColumns] = useState([]);
  const [savedJobWorkspaceColumnViewId, setSavedJobWorkspaceColumnViewId] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [draftVisibleColumns, setDraftVisibleColumns] = useState([]);

  const candidateDetailsRef = useRef(null);
  const hasAppliedDefaultViewRef = useRef(false);
  const recentActivityContainerRef = useRef(null);
  const notificationSocketRef = useRef(null);
  const notificationPingIntervalRef = useRef(null);
  const notificationPingTimeoutRef = useRef(null);
  const notificationConnectTimeoutRef = useRef(null);
  const notificationReconnectTimeoutRef = useRef(null);
  const notificationReconnectAttemptsRef = useRef(0);
  const notificationConnectingRef = useRef(false);
  const notificationUnmountedRef = useRef(false);
  const dropdownRef = useRef(null);
  const dropdownBtnRef = useRef(null);
  const notificationUnreadCount = notificationsState?.unread_count || 0;
  const NOTIFICATION_PING_INTERVAL = 30000;
  const NOTIFICATION_PING_TIMEOUT = 10000;
  const MAX_NOTIFICATION_RECONNECT_ATTEMPTS = 5;
  const BASE_NOTIFICATION_RECONNECT_DELAY = 1000;

  const CANDIDATE_PAGE_SIZE = 10;
  const RECENT_ACTIVITY_LIMIT = 5;
  const JOB_WORKSPACE_PAGE_SIZE = 10;
  const JOB_WORKSPACE_COLUMN_SAVED_VIEW_SCOPE = "member_dashboard_job_pipeline"

  const DATE_FILTER_OPTIONS = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Week", value: "this_week" },
    { label: "Month", value: "this_month" },
  ];

    const calculateDaysLeft = () => {
    if (
      subscriptionDetails?.status === "trialing" &&
      subscriptionDetails?.trial_end
    ) {
      const trialEnd = new Date(subscriptionDetails.trial_end);
      const now = new Date();
      const timeDiff = trialEnd.getTime() - now.getTime();
      const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return Math.max(0, daysLeft);
    }
    return 0;
  };

  const handleCloseSnackbar = () => {
    setShowTrialSnackbar(false);
  };

    useEffect(() => {
      if (
        subscriptionDetails?.status === "trialing" &&
        !hasShownSnackbarRef.current
      ) {
        const daysLeft = calculateDaysLeft();
        setDaysLeftInTrial(daysLeft);
  
        if (daysLeft > 0) {
          setShowTrialSnackbar(true);
          hasShownSnackbarRef.current = true;
        }
      }
    }, [subscriptionDetails]);
  const toggleNotificationPopup = (event) => {
    event.stopPropagation();
    setIsNotificationPopupOpen(!isNotificationPopupOpen);
  };

  const fetchTenantDetails = useCallback(async () => {
    try {
      const requestConfig = {
        headers: {
          "X-API-Key": TENANT_CORE_API_KEY,
        },
      };
      const response = await get(
        VYLABS_BASE_URL,
        GET_TENANT_DETAILS,
        requestConfig,
      );
      setTenantDetails(response?.tenant || null);
      localStorage.setItem("tenant", JSON.stringify(response));
      setTenantFetchError(false);
    } catch (err) {
      console.error("Dashboard GET_TENANT_DETAILS Error:", err);
      if (err.response?.status === 403) {
        setTenantFetchError(true);
      } else {
        setTenantFetchError(false);
      }
      setTenantDetails(null);
    }
  }, [setTenantDetails]);

  const getStageName = (systemKey) => {
    if(Array.isArray(systemKey)) {
      return (systemKey.map((i) => callStageMap[i]));
    }
    else return callStageMap[systemKey] || systemKey || "N/A";
  };

  const closeNotificationWebSocket = useCallback(() => {
    if (notificationSocketRef.current) {
      notificationSocketRef.current.close(
        1000,
        "Dashboard notification cleanup",
      );
      notificationSocketRef.current = null;
    }
    if (notificationPingIntervalRef.current) {
      clearInterval(notificationPingIntervalRef.current);
      notificationPingIntervalRef.current = null;
    }
    if (notificationPingTimeoutRef.current) {
      clearTimeout(notificationPingTimeoutRef.current);
      notificationPingTimeoutRef.current = null;
    }
    if (notificationConnectTimeoutRef.current) {
      clearTimeout(notificationConnectTimeoutRef.current);
      notificationConnectTimeoutRef.current = null;
    }
    if (notificationReconnectTimeoutRef.current) {
      clearTimeout(notificationReconnectTimeoutRef.current);
      notificationReconnectTimeoutRef.current = null;
    }
    notificationConnectingRef.current = false;
  }, []);

  const startNotificationPingInterval = useCallback((ws) => {
    if (notificationPingIntervalRef.current) {
      clearInterval(notificationPingIntervalRef.current);
    }

    const sendPing = () => {
      if (ws.readyState !== WebSocket.OPEN) return;
      console.warn("Sending ping");
      ws.send("ping");
      if (notificationPingTimeoutRef.current) {
        clearTimeout(notificationPingTimeoutRef.current);
      }
      notificationPingTimeoutRef.current = setTimeout(() => {
        ws.close(1000, "Notification ping timeout");
      }, NOTIFICATION_PING_TIMEOUT);
    };

    if (ws.readyState === WebSocket.OPEN) {
      console.warn("Sending initial ping");
    }
    sendPing();
    notificationPingIntervalRef.current = setInterval(
      sendPing,
      NOTIFICATION_PING_INTERVAL,
    );
  }, []);

  const updateNotificationStateFromPayload = useCallback(
    (notificationPayload) => {
      if (!notificationPayload?.id) return;

      setNotificationsState((prev) => {
        const previousNotifications = Array.isArray(prev?.notifications)
          ? prev.notifications
          : [];
        const alreadyExists = previousNotifications.some(
          (item) => item.id === notificationPayload.id,
        );
        const notifications = alreadyExists
          ? previousNotifications.map((item) =>
              item.id === notificationPayload.id
                ? { ...item, ...notificationPayload }
                : item,
            )
          : [notificationPayload, ...previousNotifications];

        return {
          ...prev,
          notifications,
          unread_count:
            typeof notificationPayload.unread_count === "number"
              ? notificationPayload.unread_count
              : (prev?.unread_count || 0) + (alreadyExists ? 0 : 1),
        };
      });
    },
    [setNotificationsState],
  );

  const initializeNotificationWebSocket = useCallback(() => {
    const token = localStorage.getItem("token");
    const isPublicRoute = [
      "/",
      "/login",
      "/signup",
      "/admin-signup",
      "/member-signup",
      "/forgot-password",
      "/reset-password",
    ].includes(window.location.pathname);
    if (
      !token ||
      !userDetails?.id ||
      isPublicRoute ||
      notificationConnectingRef.current
    ) {
      return;
    }
    if (
      notificationSocketRef.current &&
      notificationSocketRef.current.readyState === WebSocket.OPEN
    ) {
      return;
    }

    notificationConnectingRef.current = true;
    if (notificationSocketRef.current) {
      notificationSocketRef.current.close();
    }
    if (notificationPingIntervalRef.current) {
      clearInterval(notificationPingIntervalRef.current);
      notificationPingIntervalRef.current = null;
    }
    if (notificationPingTimeoutRef.current) {
      clearTimeout(notificationPingTimeoutRef.current);
      notificationPingTimeoutRef.current = null;
    }
    if (notificationConnectTimeoutRef.current) {
      clearTimeout(notificationConnectTimeoutRef.current);
      notificationConnectTimeoutRef.current = null;
    }
    if (notificationReconnectTimeoutRef.current) {
      clearTimeout(notificationReconnectTimeoutRef.current);
      notificationReconnectTimeoutRef.current = null;
    }

    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";
    const baseHost = String(WEB_SOCKET_URL)
      .replace(/^wss?:\/\//, "")
      .replace(/^https?:\/\//, "")
      .replace(/^\/+/, "");
    const wsUrl = `${wsProtocol}${baseHost}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}&channel_id=${encodeURIComponent(userDetails.id)}`;

    try {
      console.log("Creating new WebSocket connection...");
      const ws = new WebSocket(wsUrl);
      notificationSocketRef.current = ws;

      ws.onopen = () => {
        console.log("WebSocket connection established");
        notificationReconnectAttemptsRef.current = 0;
        notificationConnectingRef.current = false;
        startNotificationPingInterval(ws);
      };

      ws.onmessage = (event) => {
        if (event.data === "pong") {
          console.warn("Pong received");
          if (notificationPingTimeoutRef.current) {
            clearTimeout(notificationPingTimeoutRef.current);
            notificationPingTimeoutRef.current = null;
          }
          return;
        }

        try {
          console.log("Raw WebSocket message:", event.data);
          const cleanedMessage = event.data.trim();
          const messageParts = cleanedMessage.split(/\|(.+)/, 2);
          if (messageParts.length !== 2) return;

          const topic = messageParts[0];
          const baseTopic = topic.split(":")[0];
          if (baseTopic !== "notification") {
            console.log("Ignored WebSocket topic:", baseTopic);
            return;
          }

          const notificationPayload = JSON.parse(messageParts[1]);
          console.log("Received notification:", notificationPayload);
          updateNotificationStateFromPayload(notificationPayload);
        } catch (error) {
          console.error(
            "Error processing notification WebSocket message:",
            error,
          );
        }
      };

      ws.onclose = (event) => {
        console.log("WebSocket connection closed", event);
        notificationConnectingRef.current = false;
        if (notificationPingIntervalRef.current) {
          clearInterval(notificationPingIntervalRef.current);
          notificationPingIntervalRef.current = null;
        }
        if (notificationPingTimeoutRef.current) {
          clearTimeout(notificationPingTimeoutRef.current);
          notificationPingTimeoutRef.current = null;
        }

        if (
          !notificationUnmountedRef.current &&
          event.code !== 1000 &&
          notificationReconnectAttemptsRef.current <
            MAX_NOTIFICATION_RECONNECT_ATTEMPTS
        ) {
          const delay = Math.min(
            BASE_NOTIFICATION_RECONNECT_DELAY *
              Math.pow(2, notificationReconnectAttemptsRef.current),
            30000,
          );
          notificationReconnectTimeoutRef.current = setTimeout(() => {
            notificationReconnectAttemptsRef.current += 1;
            initializeNotificationWebSocket();
          }, delay);
        }
      };

      ws.onerror = (error) => {
        console.warn("Notification WebSocket error:", error);
        notificationConnectingRef.current = false;
      };
    } catch (error) {
      console.error("Error creating notification WebSocket:", error);
      notificationConnectingRef.current = false;
    }
  }, [
    startNotificationPingInterval,
    updateNotificationStateFromPayload,
    userDetails?.id,
  ]);

  useEffect(() => {
    const fetchNotificationsForBadge = async () => {
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${NOTIFICATIONS_GET}?unread_only=true`,
        );
        if (response) {
          setNotificationsState({
            notifications: response?.notifications || [],
            unread_count: response?.unread_count || 0,
          });
        }
      } catch (error) {
        console.error("Dashboard notifications fetch error:", error);
      }
    };

    const token = localStorage.getItem("token");
    const isPublicRoute = [
      "/",
      "/login",
      "/signup",
      "/admin-signup",
      "/member-signup",
      "/forgot-password",
      "/reset-password",
    ].includes(window.location.pathname);
    if (!token || !userDetails?.id || isPublicRoute) return undefined;

    notificationUnmountedRef.current = false;
    fetchNotificationsForBadge();
    notificationConnectTimeoutRef.current = setTimeout(() => {
      initializeNotificationWebSocket();
    }, 250);

    return () => {
      notificationUnmountedRef.current = true;
      closeNotificationWebSocket();
    };
  }, [
    closeNotificationWebSocket,
    initializeNotificationWebSocket,
    setNotificationsState,
    userDetails?.id,
  ]);

  const getRecruiterDashboardSummary = async (filtersToUse = filters) => {
    const query = buildFilterQuery(filtersToUse);
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${METRICS_RECRUITER_DASHBOARD_SUMMARY}?${query}`,
      );
      setDashboardSummary(response);
    } catch (error) {
      console.error("error in getRecruiterDashboardSummary", error);
    }
  };

  const getRecentActivity = async (
    filtersToUse = filters,
    offset = 0,
    append = false,
  ) => {
    const query = buildFilterQuery(filtersToUse);

    try {
      if (!append) {
        setRecentActivityLoader(true);
      }

      setRecentActivityLoading(true);

      const response = await get(
        VYLABS_BASE_URL,
        `${METRICS_RECENT_ACTIVITY}?limit=${RECENT_ACTIVITY_LIMIT}&offset=${offset}&${query}`,
      );

      const activities = response.activities || [];

      setRecentActivity((prev) =>
        append ? [...prev, ...activities] : activities,
      );

      setRecentActivityOffset(offset + activities.length);
      setRecentActivityHasMore(response.hasMore);
    } catch (error) {
      console.error("error in getRecentActivity", error);
    } finally {
      setRecentActivityLoading(false);
      if (!append) {
        setRecentActivityLoader(false);
      }
    }
  };

  const renderRecentActivity = () => (
    <>
      {recentActivity.map((item, index) => (
        <div
          key={item.id || index}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "14px",
            marginBottom: "5px",
            marginRight: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: getStageColor(getStageName(item.stage)),
              }}
            />

            {index !== recentActivity.length - 1 && (
              <div
                style={{
                  width: "1px",
                  flex: 1,
                  background: "#7A7A7A",
                  minHeight: "52px",
                  marginTop: "2px",
                }}
              />
            )}
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {item.candidateName} → {getStageName(item.stage)}
              </div>

              <div
                style={{
                  color: "#7A7A7A",
                  fontSize: "14px",
                }}
              >
                {moment(item.occurredAt).format("hh:mm A")}
              </div>
            </div>

            <div
              style={{
                marginTop: "4px",
                color: "#6D6D6D",
                fontSize: "14px",
              }}
            >
              {item.jobTitle} • {item.clientName}
            </div>
          </div>
        </div>
      ))}
    </>
  );

  const getCandidateWorkspace = async (
    page = 1,
    filtersToUse = filters,
    searchText,
    sortToUse = candidateWorkspaceSort,
  ) => {
    const query = buildFilterQuery(filtersToUse);
    const searchQuery =
      searchText && searchText.trim()
        ? `&search=${encodeURIComponent(searchText.trim())}`
        : "";
    const sortQuery = sortToUse.sortBy
      ? `&sortBy=${encodeURIComponent(sortToUse.sortBy)}&sortOrder=${encodeURIComponent(sortToUse.sortOrder)}`
      : "";

    try {
      setCandidateWorkspaceLoader(true);

      const response = await get(
        VYLABS_BASE_URL,
        `${METRICS_CANDIDATE_WORKSPACE}?page=${page}&limit=${CANDIDATE_PAGE_SIZE}&${query}${searchQuery}${sortQuery}`,
      );

      setCandidateWorkspace(response.candidates || []);
      setCandidateCurrentPage(page);
      setCandidateTotalRows(response.total || 0);
    } catch (error) {
      console.error("error in getCandidateWorkspace", error);
    } finally {
      setCandidateWorkspaceLoader(false);
    }
  };

  const getJobWorkspace = async (page = 1, filtersToUse = filters, jobSort) => {
    const params = new URLSearchParams();
    params.append("page", page - 1);
    params.append("limit", JOB_WORKSPACE_PAGE_SIZE);
    if (filtersToUse?.jobId) params.append("jobs", filtersToUse.jobId);
    if(jobSort) {
      params.append("sortBy", (jobSort.sortBy || jobWorkspaceSort?.sortBy));
      params.append("sortOrder", (jobSort.sortOrder || jobWorkspaceSort?.sortOrder));
    }
    if(selectedTagBasedFilter) {
      params.append("recruiterScope", selectedTagBasedFilter);
    }
    const query = buildFilterQuery(filtersToUse);

    try {
      setJobWorkspaceLoader(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${METRICS_JOB_WORKSPACE}?${params.toString()}&${query}`,
      );
      const responseStageCounts = Array.isArray(response?.stageCounts)
        ? response.stageCounts
        : [];
      const jobs = Array.isArray(response?.jobs) ? response.jobs : [];

      setJobWorkspace(
        jobs.map((job) => ({
          ...job,
          displayStageCounts: Array.isArray(job.stageCounts)
            ? job.stageCounts
            : Array.isArray(job.stages)
              ? job.stages
              : responseStageCounts,
        })),
      );
      setJobWorkspaceTotal(response?.total || 0);
      setJobWorkspaceCurrentPage(page);
    } catch (error) {
      console.error("error in getJobWorkspace", error);
      setJobWorkspace([]);
    } finally {
      setJobWorkspaceLoader(false);
    }
  };

  
  const jobWorkspaceStageNames = useMemo(
    () =>
      Array.from(
        jobWorkspace
          .reduce((stageMap, row) => {
            (Array.isArray(row.displayStageCounts)
              ? row.displayStageCounts
              : []
            ).forEach((stage) => {
              const name = stage?.name || stage?.stage;
              const systemKey = stage?.system_key || stage?.systemKey;
              const key =
                systemKey || (name ? name.trim().toLowerCase() : "");

              if (key && !stageMap.has(key)) {
                stageMap.set(key, {
                  name: name || systemKey,
                  system_key: systemKey || key,
                });
              }
            });
            return stageMap;
          }, new Map())
          .values(),
      ),
    [jobWorkspace],
  );

  const allJobWorkspaceColumns = useMemo(
    () => [
      {
        columnKey: "job",
        name: "Job",
        selector: (row) => row.jobTitle || "N/A",
        sortable: true,
        sortBy: "jobTitle",
        grow: 3,
        cell: (row) => (
          <CustomTooltip title={row.jobTitle || "N/A"} arrow>
            <div>{applyEllipsis(row.jobTitle || "N/A", 15)}</div>
          </CustomTooltip>
        ),
      },
      {
        columnKey: "client",
        name: "Client",
        selector: (row) => row.clientName || "N/A",
        sortable: true,
        sortBy: "clientName",
        grow: 2,
        cell: (row) => (
          <CustomTooltip title={row.clientName || "N/A"} arrow>
            <div>{applyEllipsis(row.clientName || "N/A", 15)}</div>
          </CustomTooltip>
        ),
      },
      {
        columnKey: "priority",
        name: "Priority",
        selector: (row) =>
          priority.find(
            (item) => Number(item.id ?? item.value) === Number(row.priority),
          )?.name || "N/A",
        minWidth: "120px",
        sortable: true,
        sortBy: "priority",
        cell: (row) => {
          const priorityData = priority.find(
            (item) => Number(item.id ?? item.value) === Number(row.priority),
          );
          const priorityIcon = PRIORITY_ICON_MAP[priorityData?.icon];

          return (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                color: priorityData?.color || "#6B7280",
                fontWeight: 600,
              }}
            >
              {priorityIcon && (
                <img
                  src={priorityIcon}
                  alt={priorityData?.name || "Priority"}
                  style={{ width: "16px", height: "16px" }}
                />
              )}
              {priorityData?.name || priorityData?.title || "N/A"}
            </span>
          );
        },
      },
      {
        columnKey: "tag",
        name: "Tag",
        selector: (row) => row.recruiter_flag ?? "N/A",
        cell: (row) => {
          return (
            <div>
              {row.recruiter_flag === "tracked" ? (
                <div style={{ 
                  color: "#E6A817", 
                  backgroundColor: "var(--body__background)", 
                  border: "1px solid #E6A817", 
                  borderRadius: "16px",
                  padding: "3px 5px" 
                }}>
                  {toCapitalize(row.recruiter_flag)}
                </div>
              ) : (
                <div style={{ 
                  color: "#0D9488", 
                  backgroundColor: "var(--body__background)", 
                  border: "1px solid #0D9488", 
                  borderRadius: "16px",
                  padding: "3px 5px"  
                  }}>
                  {toCapitalize(row.recruiter_flag)}
                </div>
              )}
            </div>
          );
        }
      },
      {
        columnKey: "openings",
        name: "Openings",
        selector: (row) => row.openings ?? 0,
        sortable: true,
        sortBy: "openings",
        center: true,
      },
      {
        columnKey: "candidates",
        name: "Candidates",
        selector: (row) => row.totalCandidates ?? 0,
        center: true,
      },
      ...jobWorkspaceStageNames.map((stageDefinition) => {
        const systemKey = stageDefinition.system_key;

        return {
          columnKey: systemKey,
          isCustomizable: true,
          name: toCapitalize(stageDefinition.name),
          selector: (row) => {
            const stage = (
              Array.isArray(row.displayStageCounts)
                ? row.displayStageCounts
                : []
            ).find(
              (item) =>
                (item.system_key || item.systemKey) === systemKey ||
                (item.stage || item.name) === stageDefinition.name,
            );
            return stage?.count ?? stage?.total ?? 0;
          },
          cell: (row) => {
            const stage = (
              Array.isArray(row.displayStageCounts)
                ? row.displayStageCounts
                : []
            ).find(
              (item) =>
                (item.system_key || item.systemKey) === systemKey ||
                (item.stage || item.name) === stageDefinition.name,
            );
            return stage?.count ?? stage?.total ?? 0;
          },
          center: true,
          minWidth: "110px",
          sortable: true,
          sortBy: `stages.${systemKey}`,
        };
      }),
      {
        columnKey: "completion",
        name: "Completion",
        selector: (row) => row.completion || "N/A",
        center: true,
        sortable: true,
        sortBy: "completion",
      },
    ],
    [jobWorkspaceStageNames, priority],
  );

  const jobWorkspaceColumns = useMemo(
    () =>
      allJobWorkspaceColumns.filter(
        (column) =>
          !column.isCustomizable ||
          visibleColumns.includes(column.columnKey),
      ),
    [allJobWorkspaceColumns, visibleColumns],
  );

  const customizableJobWorkspaceColumns = useMemo(
    () => allJobWorkspaceColumns.filter((column) => column.isCustomizable),
    [allJobWorkspaceColumns],
  );

  const jobWorkspaceColumnSignature = customizableJobWorkspaceColumns
    .map((column) => `${column.columnKey}:${column.name}`)
    .join("|");

  const columnsForCustomize = useMemo(
    () => getCustomizeColumnsFromTableColumns(customizableJobWorkspaceColumns),
    [jobWorkspaceColumnSignature],
  );

  const jobWorkspaceSortOptions = [
    { title: "Priority", value: "priority" },
    { title: "Job Title", value: "jobTitle" },
    { title: "Client Name", value: "clientName" },
    { title: "Openings", value: "openings" },
    { title: "Completion", value: "completion" },
    { title: "Created At", value: "created_at" },
    { title: "Proposed", value: "stages.proposed" },
    { title: "Interested", value: "stages.interested" },
    { title: "Joined", value: "stages.joined" },
    { title: "Applied", value: "stages.applied" },
    { title: "Interview Scheduled", value: "stages.interview_scheduled" },
    { title: "New Profile", value: "stages.new_profile" },
    { title: "Offered", value: "stages.offered" },
  ];

  const handleJobWorkspaceSort = () => {
    if (!selectedJobWorkspaceColumn) {
      Toast("error", "Please select a sort by");
      return;
    };
    const sortOrder = jobWorkspaceSort?.sortBy === selectedJobWorkspaceColumn &&
    jobWorkspaceSort?.sortOrder === "asc" ? "desc" : "asc";
    const sort = {
      sortBy: selectedJobWorkspaceColumn,
      sortOrder
    }
    setJobWorkspaceCurrentPage(1);
    setJobWorkspaceSort(sort);
    getJobWorkspace(1, filters, sort);
  }

  const handleCandidateWorkspaceSort = () => {
    if (!selectedCandidateWorkspaceColumn) {
      Toast("error", "Please select a sort by");
      return;
    }
  
    const sortOrder =
      candidateWorkspaceSort?.sortBy === selectedCandidateWorkspaceColumn &&
      candidateWorkspaceSort?.sortOrder === "asc"
        ? "desc"
        : "asc";
  
    const nextSort = {
      sortBy: selectedCandidateWorkspaceColumn,
      sortOrder,
    };
  
    setCandidateWorkspaceSort(nextSort);
    setCandidateCurrentPage(1);
  
    getCandidateWorkspace(1, filters, searchText, nextSort);
  };

  const handleSearch = () => {
    getCandidateWorkspace(1, filters, searchText);
  };

  const handleClearSearch = () => {
    setSearchText("");
    getCandidateWorkspace(1, filters, "");
  };

  const candidateWorkspaceColumns = [
    {
      name: "Candidate",
      selector: (row) => row.candidateName || "",
      sortField: "candidateName",
      sortable: true,
      grow: 3,
      cell: (row) => {
        const initials = row.candidateName
          ?.split(" ")
          .slice(0, 2)
          .map((word) => word[0])
          .join("")
          .toUpperCase();

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
            }}
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                background: "#EEF2FF",
                color: "#4F46E5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                flexShrink: 0,
              }}
            >
              {initials}
            </div>

            <div>
              <CustomTooltip title={row.candidateName || "N/A"} arrow>
                <div
                  style={{
                    fontWeight: 600,
                  }}
                >
                  {applyEllipsis(row.candidateName || "N/A", 15)}
                </div>
              </CustomTooltip>
              <div
                style={{
                  fontSize: "13px",
                  color: "#777",
                }}
              >
                {row.yearsOfExperience} yrs
                {row.city && ` • ${row.city}`}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      name: "Phone",
      selector: (row) => row.phone || "",
      sortField: "phone",
      sortable: true,
      grow: 2,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#777",
          }}
        >
          <img src={phoneIcon} alt="Phone" width={14} />
          {row.phone || "N/A"}
        </div>
      ),
    },
    {
      name: "Email",
      selector: (row) => row.email || "",
      sortField: "email",
      sortable: true,
      grow: 3,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#777",
          }}
        >
          <img src={mailIcon} alt="Mail" width={14} />
          {row.email || "N/A"}
        </div>
      ),
    },
    {
      name: "Job",
      selector: (row) => row.jobTitle || "",
      sortField: "jobTitle",
      sortable: true,
      grow: 3,
      cell: (row) => (
        <div>
          <div
            style={{
              fontWeight: 600,
            }}
          >
            {row.jobTitle}
          </div>

          <div
            style={{
              fontSize: "13px",
              color: "#777",
            }}
          >
            Client • {row.clientName}
          </div>
        </div>
      ),
    },
    {
      name: "Stage",
      selector: (row) => getStageName(row.stage),
      sortField: "stage",
      sortable: true,
      grow: 2,
      cell: (row) => {
        const stageColor = getStageColor(row.stage);

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "4px 12px",
              borderRadius: "999px",
              color: stageColor,
              border: `1px solid ${stageColor}`,
              background: `${stageColor}20`,
              fontSize: "13px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {getStageName(row.stage)}
          </div>
        );
      },
    },
    {
      name: "Action",
      width: "90px",
      cell: (row) => (
        <img
          src={viewCandidateIcon}
          alt="View"
          style={{
            cursor: "pointer",
          }}
          onClick={() => handleViewCandidate(row)}
        />
      ),
    },
  ];

  
  const candidateWorkspaceSortOptions = [
    { title: "Candidate Name", value: "candidateName" },
    { title: "Years of Experience", value: "yearsOfExperience" },
    { title: "Job Title", value: "jobTitle" },
    { title: "Client Name", value: "clientName" },
    { title: "Pipeline Stage", value: "stage" },
    { title: "Updated At", value: "updatedAt" },
    { title: "Candidate Email", value: "email" },
    { title: "Candidate Phone", value: "phone" },
    { title: "Candidate City", value: "city" },
    { title: "Candidate Designation", value: "designation" },
  ];

  const getRecruiterDashboardFollowups = async (filtersToUse = filters) => {
    setFollowUpsLoader(true);
    const query = buildFilterQuery(filtersToUse);
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${METRICS_RECRUITER_DASHBOARD_FOLLOWUPS}?${query}`,
      );

      setFollowups(response);
      setFollowUpsLoader(false);
    } catch (error) {
      console.error("error in getRecruiterDashboardFollowups", error);
      setFollowUpsLoader(false);
    }
  };

  const renderSection = (title, color, data) => (
    <>
      <div
        style={{
          marginTop: "20px",
          marginBottom: "12px",
          color,
          fontWeight: 700,
          fontSize: "14px",
        }}
      >
        {title} · {data.length}
      </div>

      {data.map((item) => (
        <div
          key={item.id}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            marginBottom: "18px",
          }}
        >
          <div
            style={{
              width: "38px",
              height: "38px",
              borderRadius: "50%",
              background: "#EBF1FF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#5358EE",
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {item.initials}
          </div>

          <div>
            <div
              style={{
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              {item.name}
            </div>

            <div
              style={{
                color: "#707070",
                fontSize: "14px",
                marginTop: "2px",
              }}
            >
              {getStageName(item.stage)} • {moment(item.callback_at).format("hh:mm A")}
            </div>
          </div>
        </div>
      ))}
    </>
  );

  useEffect(() => {   
    getJobWorkspace(1, filters);   
  }, [selectedTagBasedFilter]);

  useEffect(() => {
    fetchTenantDetails();

    const loadCallStages = async () => {
      const stageMap = await fetchCallStages();
      setCallStageMap(stageMap);
    };

    loadCallStages();
  }, [fetchTenantDetails]);

  const buildFilterQuery = (filters) => {
    const params = new URLSearchParams();

    if (filters?.stage) {
      params.append("stage", filters.stage);
    }

    if (filters?.jobId) {
      params.append("jobId", filters.jobId);
    }

    if (filters?.time) {
      params.append("time", filters.time);
    }

    return params.toString();
  };

  const refreshMemberDashboard = (
    filtersToUse = filters,
    workspaceSearchText = searchText,
  ) => {
    setRecentActivity([]);
    setRecentActivityOffset(0);
    setRecentActivityHasMore(true);
    setCandidateCurrentPage(1);

    getRecruiterDashboardSummary(filtersToUse);
    getRecentActivity(filtersToUse, 0, false);
    getCandidateWorkspace(1, filtersToUse, workspaceSearchText);
    getRecruiterDashboardFollowups(filtersToUse);
  };

  const applyMemberDashboardFilters = (
    filtersToApply,
    workspaceSearchText = searchText,
  ) => {
    const nextFilters = {
      stage: filtersToApply?.stages || "",
      time: filtersToApply?.time || "today",
      jobId: filtersToApply?.jobId || "",
      jobTitle: filtersToApply?.jobTitle || "",
      search: filtersToApply?.search || "",
    };

    setFilters(nextFilters);
    refreshMemberDashboard(nextFilters, workspaceSearchText);
    return nextFilters;
  };

  const fetchSavedViews = useCallback(async () => {
    try {
      setIsLoadingSavedViews(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_SAVED_VIEWS}?scope=${MEMBER_DASHBOARD_SAVED_VIEW_SCOPE}`,
      );
      const views = Array.isArray(response?.views) ? response.views : [];
      setSavedViews(views);
      return views;
    } catch (error) {
      console.error("Member dashboard fetchSavedViews error:", error);
      setSavedViews([]);
      return [];
    } finally {
      setIsLoadingSavedViews(false);
    }
  }, []);

  const savedViewOptions = useMemo(
    () =>
      savedViews
        .filter((view) => view?.id && view?.name)
        .map((view) => ({ label: view.name, value: view.id })),
    [savedViews],
  );

  const handleSavedViewChange = (option) => {
    if (!option) {
      setSelectedSavedViewId(null);
      applyMemberDashboardFilters({ time: "today" });
      return;
    }

    const view = savedViews.find((item) => item.id === option.value);
    if (!view) return;

    setSelectedSavedViewId(view.id);
    applyMemberDashboardFilters(view.filters || {});
  };

  const activeSavedViewOption = useMemo(() => {
    const view = savedViews.find((item) => item.id === selectedSavedViewId);
    if (!view) return null;

    const viewFilters = view.filters || {};
    const timeMatches = (filters.time || "today") === (viewFilters.time || "today");
    const stageMatches = String(filters.stage || "") === String(viewFilters.stages || "");
    const jobMatches = String(filters.jobId || "") === String(viewFilters.jobId || "");

    return timeMatches && stageMatches && jobMatches
      ? { label: view.name, value: view.id }
      : null;
  }, [filters, savedViews, selectedSavedViewId]);

  const hasSavedViewEligibleFilters =
    Boolean(filters.jobId) || Boolean(filters.stage);

  const isCreateViewButtonActive =
    hasSavedViewEligibleFilters && !activeSavedViewOption;

  const formatDateForDisplay = (date) => {
    if (!date) return "";

    return new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(",", "");
  };

  const getMemberDashboardDateRange = useCallback(() => {
    const today = new Date();
    const startOfDay = (date) =>
      new Date(date.getFullYear(), date.getMonth(), date.getDate());

    if (filters.time === "yesterday") {
      const yesterday = startOfDay(today);
      yesterday.setDate(yesterday.getDate() - 1);

      return { start: yesterday, end: yesterday };
    }

    if (filters.time === "this_week") {
      const start = startOfDay(today);
      start.setDate(start.getDate() - start.getDay());

      const end = new Date(start);
      end.setDate(start.getDate() + 6);

      return { start, end };
    }

    if (filters.time === "this_month") {
      return {
        start: new Date(today.getFullYear(), today.getMonth(), 1),
        end: new Date(today.getFullYear(), today.getMonth() + 1, 0),
      };
    }

    const currentDay = startOfDay(today);
    return { start: currentDay, end: currentDay };
  }, [filters.time]);

  const memberDashboardDateRangeLabel = useMemo(() => {
    const range = getMemberDashboardDateRange();
    const startLabel = formatDateForDisplay(range.start);
    const endLabel = formatDateForDisplay(range.end);

    return startLabel === endLabel ? startLabel : `${startLabel} - ${endLabel}`;
  }, [getMemberDashboardDateRange]);

  const selectedStageName = filters.stage ? getStageName(filters.stage) : "";
  const selectedJobName = filters.jobTitle || "";

  const handleCreateViewOpen = useCallback(() => {
    if (!isCreateViewButtonActive) return;
    setViewOpen(true);
  }, [isCreateViewButtonActive]);

  const handleCreateViewClose = useCallback(() => {
    setViewOpen(false);
    setSavedViewName("");
    setSavedViewIsDefault(false);
  }, []);

  const createFilter = useCallback(async () => {
    const trimmedName = savedViewName.trim();

    if (!trimmedName) {
      Toast("error", "Please enter saved view name");
      return;
    }

    if (!isCreateViewButtonActive) {
      Toast("error", "Please select at least one filter");
      return;
    }

    const savedFilters = {};

    if (filters.time) savedFilters.time = filters.time;
    if (filters.stage) savedFilters.stages = filters.stage;
    if (filters.jobId) {
      savedFilters.jobId = filters.jobId;
      savedFilters.jobTitle = filters.jobTitle;
    }

    const payload = {
      filters: savedFilters,
      isDefault: savedViewIsDefault,
      name: trimmedName,
      scope: MEMBER_DASHBOARD_SAVED_VIEW_SCOPE,
    };

    try {
      setIsCreatingSavedView(true);
      const response = await post(VYLABS_BASE_URL, CREATE_SAVED_VIEWS, payload);
      Toast("success", "Saved view created successfully");
      const views = await fetchSavedViews();
      const createdViewId = response?.view?.id || response?.id;
      const createdView =
        views.find((view) => String(view.id) === String(createdViewId)) ||
        views.find((view) => view.name === trimmedName);
      if (createdView?.id) {
        setSelectedSavedViewId(createdView.id);
      }
      handleCreateViewClose();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Failed to create saved view";
      Toast("error", errorMessage);
    } finally {
      setIsCreatingSavedView(false);
    }
  }, [
    fetchSavedViews,
    filters,
    handleCreateViewClose,
    isCreateViewButtonActive,
    savedViewName,
    savedViewIsDefault,
  ]);

  const handleSavedViewDeleteClose = useCallback(() => {
    if (isDeletingSavedView) return;
    setIsSavedViewDeleteDialogOpen(false);
    setSavedViewPendingDelete(null);
  }, [isDeletingSavedView]);

  const handleDeleteViews = useCallback(
    async (savedViewId = selectedSavedViewId) => {
      if (!savedViewId) {
        Toast("error", "Please select a saved filter to delete");
        return;
      }

      try {
        setIsDeletingSavedView(true);
        await deleteRequest(
          VYLABS_BASE_URL,
          `${DELETE_SAVED_VIEWS}/${encodeURIComponent(savedViewId)}`,
        );
        Toast("success", "Saved filter deleted successfully");
        if (String(savedViewId) === String(selectedSavedViewId)) {
          setSelectedSavedViewId(null);
        }
        await fetchSavedViews();
        setIsSavedViewDeleteDialogOpen(false);
        setSavedViewPendingDelete(null);
      } catch (error) {
        console.error("Error deleting saved view", error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to delete saved filter";
        Toast("error", errorMessage);
      } finally {
        setIsDeletingSavedView(false);
      }
    },
    [fetchSavedViews, selectedSavedViewId],
  );

  useEffect(() => {
    fetchSavedViews().then((views) => {
      const defaultView = views.find((view) => view?.isDefault);
      if (defaultView && !hasAppliedDefaultViewRef.current) {
        hasAppliedDefaultViewRef.current = true;
        setSelectedSavedViewId(defaultView.id);
        applyMemberDashboardFilters(defaultView.filters || {});
        return;
      }

      refreshMemberDashboard(filters);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchSavedViews]);

  const handleFilterApply = (selectedFilters) => {
    const stage =
      selectedFilters.find((f) => f.type === "call_stage")?.value || "";

    const time =
      selectedFilters.find((f) => f.type === "date")?.value || "today";

    const jobFilter = selectedFilters.find((f) => f.type === "job_id");
    const jobId = jobFilter?.value || "";
    const jobTitle = jobFilter?.label || "";

    const newFilters = {
      stage,
      time,
      jobId,
      jobTitle,
    };

    applyMemberDashboardFilters(newFilters);
    getJobWorkspace(1, newFilters);

    return true;
  };

  const handleRecentActivityScroll = useCallback(() => {
    const container = recentActivityContainerRef.current;

    if (!container) return;

    const reachedBottom =
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 20;

    if (reachedBottom && recentActivityHasMore && !recentActivityLoading) {
      const nextOffset = recentActivityOffset;

      getRecentActivity(filters, nextOffset, true);
    }
  }, [
    filters,
    recentActivityHasMore,
    recentActivityLoading,
    recentActivityOffset,
  ]);

  useEffect(() => {
    const container = recentActivityContainerRef.current;

    if (!container) return;

    container.addEventListener("scroll", handleRecentActivityScroll);

    return () =>
      container.removeEventListener("scroll", handleRecentActivityScroll);
  }, [handleRecentActivityScroll]);

  const getCandidateById = async (candidateId) => {
    try {
      setCandidateLoading(true);
      setIsCandidatePopupOpen(true);
      const res = await get(
        VYLABS_BASE_URL,
        `${GET_CANDIDATE_BY_ID}?id=${candidateId}`,
      );

      const fetchedCandidate = res?.candidate;
      const candidateFiles = res?.files;

      const parsedResumeData = fetchedCandidate?.parsed_resume
        ? JSON.parse(fetchedCandidate.parsed_resume)
        : null;

      const updatedCandidate = {
        ...fetchedCandidate,
        secondaryEmail: fetchedCandidate.secondary_email,
        secondaryPhone: fetchedCandidate.secondary_phone,
        vendorID: fetchedCandidate.vendor_id,
        parsedResumeData,
        files: candidateFiles || null,
        avatar: res?.profile_img_url,
        experience: fetchedCandidate.years_of_experience,
        shouldSkipFetch: true,
      };

      setSelectedCandidate(updatedCandidate);
    } catch (err) {
      console.error("error in getCandidateById", err);
    } finally {
      setCandidateLoading(false);
    }
  };

  const handleViewCandidate = (row) => {
    getCandidateById(row.candidateId);
  };

  const handleEditCandidate = () => {
    const getValidExperience = (value) => {
      const num = Number(value);

      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    let experienceValue = "";
    const directExp = getValidExperience(
      selectedCandidate?.years_of_experience,
    );

    const parsedExp = getValidExperience(
      selectedCandidate?.parsedResumeData?.BasicInfo?.YearsOfExperience,
    );

    if (directExp !== "") {
      experienceValue = directExp;
    } else if (parsedExp !== "") {
      experienceValue = parsedExp;
    }

    const candidateWithFormattedSkills = {
      ...selectedCandidate,
      name:
        selectedCandidate.name ||
        selectedCandidate.parsedResumeData?.BasicInfo?.Name ||
        "",
      email:
        selectedCandidate.email ||
        selectedCandidate.parsedResumeData?.BasicInfo?.Email ||
        "",
      secondaryEmail:
        selectedCandidate.secondaryEmail ||
        selectedCandidate.parsedResumeData?.BasicInfo?.secondaryEmail ||
        "",
      phone:
        selectedCandidate.phone ||
        selectedCandidate.parsedResumeData?.BasicInfo?.PhoneNumber ||
        "",
      lineAddress1:
        selectedCandidate.lineAddress1 ||
        selectedCandidate.parsedResumeData?.BasicInfo?.lineAddress1 ||
        "",
      lineAddress2:
        selectedCandidate.lineAddress2 ||
        selectedCandidate.parsedResumeData?.BasicInfo?.lineAddress2 ||
        "",
      preferredSalary:
        selectedCandidate.preferredSalary ||
        selectedCandidate.parsedResumeData?.BasicInfo?.preferredSalary ||
        "",
      zipCode:
        selectedCandidate.zipCode ||
        selectedCandidate.parsedResumeData?.BasicInfo?.zipCode ||
        "",
      secondaryPhone:
        selectedCandidate.secondaryPhone ||
        selectedCandidate.parsedResumeData?.BasicInfo?.secondaryPhone ||
        "",
      city:
        selectedCandidate.city ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationCity ||
        "",
      state:
        selectedCandidate.state ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationState ||
        "",
      country:
        selectedCandidate.country ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationCountry ||
        "",
      skills: Array.isArray(selectedCandidate.skills)
        ? selectedCandidate.skills
        : selectedCandidate.parsedResumeData?.Skills || [],
      vendorID:
        selectedCandidate.vendorID ||
        selectedCandidate.parsedResumeData?.BasicInfo?.vendorID ||
        "",
      designation:
        selectedCandidate.designation?.trim() ||
        selectedCandidate.parsedResumeData?.CareerHistory?.JobDetails?.[0]
          ?.JobTitle ||
        "",
      source: selectedCandidate.source,
      experience: experienceValue,
      custom_fields: selectedCandidate?.custom_fields || {},
    };

    setOriginalCandidateData({ ...selectedCandidate });
    setEditedCandidateData(candidateWithFormattedSkills);
    setIsEditingCandidate(true);
    setEmailError("");
    setEmailTouched(false);
  };

  const resetCandidateEdit = () => {
    if (originalCandidateData) {
      setSelectedCandidate(originalCandidateData);
    }
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
    setEmailError("");
    setEmailTouched(false);
  };

  const handleCandidateChange = (data) => {
    setEditedCandidateData((prev) => ({
      ...prev,
      ...data,
    }));
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      return;
    }
    const email =
      editedCandidateData.email !== undefined
        ? editedCandidateData.email
        : selectedCandidate.email || "";

    if (!email.trim()) {
      setEmailError("Email is required");
      setEmailTouched(true);
      Toast("error", "Email is required");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      setEmailTouched(true);
      Toast("error", "Please fill all required fields correctly");
      return;
    }
    setEmailError("");
    setEmailTouched(false);

    try {
      const candidateData = { id: selectedCandidate.id };

      Object.keys(editedCandidateData).forEach((key) => {
        const newValue = editedCandidateData[key];
        const oldValue = selectedCandidate[key];

        const isChanged = Array.isArray(newValue)
          ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
          : newValue !== oldValue;

        if (
          isChanged &&
          newValue !== undefined &&
          newValue !== null &&
          newValue !== ""
        ) {
          candidateData[key] = newValue;
        }
      });

      if (!candidateData.designation && selectedCandidate.designation) {
        candidateData.designation = selectedCandidate.designation;
      }

      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });

      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }

      if (candidateData.source !== undefined) {
        candidateData.source = toCamelCase(candidateData.source);
      }

      if (editedCandidateData.custom_fields) {
        const oldCustomFields = selectedCandidate.custom_fields || {};
        const newCustomFields = editedCandidateData.custom_fields;
        const hasCustomFieldChanges = Object.keys(newCustomFields).some(
          (key) => newCustomFields[key] !== oldCustomFields[key],
        );

        if (hasCustomFieldChanges) {
          candidateData.custom_fields = filterPayload({
            ...oldCustomFields,
            ...newCustomFields,
          });
        }
      }

      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
      );

      if (response) {
        await getCandidateById(selectedCandidate.id);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");
        getCandidateWorkspace(candidateCurrentPage, filters, searchText);
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      const backendMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to update candidate";
      Toast("error", backendMessage);
    }
  };

  const handleOpenCandidateDeleteDialog = () => {
    setIsDeleteCandidatePopupOpen(true);
  };

  const handleDeleteCandidate = async () => {
    setIsDeleteCandidatePopupOpen(false);
    if (selectedCandidate?.id) {
      try {
        await deleteRequest(VYLABS_BASE_URL, DELETE_CANDIDATE_DETAILS, {
          id: selectedCandidate.id,
        });
        Toast("success", "Candidate deleted successfully");
        getCandidateWorkspace(candidateCurrentPage, filters, searchText);
        setSelectedCandidate(null);
        setIsCandidatePopupOpen(false);
      } catch (error) {
        console.error("Error deleting candidate:", error);
        const backendMessage =
          error?.response?.data?.message ||
          error.message ||
          "Failed to delete candidate";
        Toast("error", backendMessage);
      }
    }
  };

  const closeCandidatePopup = () => {
    setIsCandidatePopupOpen(false);
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
    setEmailError("");
    setEmailTouched(false);
  };

  const handleJobInputChange = (_, value) => {
    if (value && value.length >= 3) {
      fetchJobOptions(value);
    } else if (!value) {
      fetchInitialJobs();
    }
  };

  const fetchJobOptions = async (inputValue) => {
    if (!inputValue) return;

    setJobOptionLoading(true);

    try {
      const response = await post(VYLABS_BASE_URL, SEARC_JOBS, {
        query: inputValue,
      });

      const data = response.jobs || [];

      const fetchOptions = [
        ...new Map(
          data.map((item) => [
            item.id,
            {
              label: item.title,
              value: item.id,
            },
          ]),
        ).values(),
      ];

      setJobListOptions(fetchOptions);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setJobOptionLoading(false);
    }
  };

  const fetchInitialJobs = async () => {
    if (jobListOptions.length > 0) return;

    setJobOptionLoading(true);

    try {
      const payload = {
        limit: JOBS_PAGE_SIZE,
        status: true,
        page: getJobsPageFromOffset(),
      };
      const response = await post(VYLABS_BASE_URL, JOBS_LIST, payload);

      const jobs = Array.isArray(response?.jobs) ? response.jobs : [];
      const options = jobs.filter((job) => job?.id).map((job) => ({
        label: job.title,
        value: job.id,
      }));

      setJobListOptions(options);
    } catch (error) {
      console.error("Error fetching initial jobs:", error);
    } finally {
      setJobOptionLoading(false);
    }
  };

  const handleGetJobWorkspaceColumnSavedViews = useCallback(async () => {
    try {
      const savedViewRes = await get(
        VYLABS_BASE_URL,
        `${GET_SAVED_VIEWS}?scope=${JOB_WORKSPACE_COLUMN_SAVED_VIEW_SCOPE}`,
      );
      const views = savedViewRes?.views || [];
      const defaultView = views.find((item) => item.isDefault);

      setSavedJobWorkspaceColumns(defaultView?.filters || []);
      setSavedJobWorkspaceColumnViewId(defaultView?.id || null);
    } catch (error) {
      console.error("error in handleGetJobWorkspaceColumnSavedViews", error);
      setSavedJobWorkspaceColumns([]);
      setSavedJobWorkspaceColumnViewId(null);
    }
  }, []);

  useEffect(() => {
    handleGetJobWorkspaceColumnSavedViews();
  }, [handleGetJobWorkspaceColumnSavedViews]);

  useEffect(() => {
    const allColumnKeys = Object.keys(columnsForCustomize);
    const savedColumnKeys = getSavedColumnKeys(
      savedJobWorkspaceColumns,
      allColumnKeys,
    );

    const nextVisibleColumns = savedJobWorkspaceColumnViewId
      ? savedColumnKeys
      : allColumnKeys;
    setVisibleColumns(nextVisibleColumns);
    setDraftVisibleColumns(nextVisibleColumns);
  }, [
    columnsForCustomize,
    savedJobWorkspaceColumnViewId,
    savedJobWorkspaceColumns,
  ]);

  const toggleColumnVisibility = (columnKey) => {
    setDraftVisibleColumns((prev) => {
      if (prev.includes(columnKey)) {
        return prev.filter((key) => key !== columnKey);
      }

      return [...prev, columnKey];
    });
  };

  const toggleCustomizeDropdown = () => {
    setCustomizeDropdownOpen((prev) => {
      if (!prev) {
        setDraftVisibleColumns(visibleColumns);
      }

      return !prev;
    });
  };

  const handleSelectAll = () => {
    setDraftVisibleColumns(Object.keys(columnsForCustomize));
  };

  const handleSelectNone = () => {
    setDraftVisibleColumns([]);
  };

  useEffect(() => {
    if (!customizeDropdownOpen) return undefined;

    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dropdownBtnRef.current &&
        !dropdownBtnRef.current.contains(event.target)
      ) {
        setCustomizeDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [customizeDropdownOpen]);

  const getSelectedJobWorkspaceColumns = () =>
    getSelectedCustomizeColumns(columnsForCustomize, draftVisibleColumns);

  const handleCreateSaveView = async () => {
    try {
      const filters = getSelectedJobWorkspaceColumns();
      const res = await post(VYLABS_BASE_URL, CREATE_SAVED_VIEWS, {
        filters,
        name: "Member Job Workspace Columns",
        scope: JOB_WORKSPACE_COLUMN_SAVED_VIEW_SCOPE,
        isDefault: true,
      });

      if (res?.view?.id) {
        Toast("success", "Created Successfully!");
        setVisibleColumns(draftVisibleColumns);
        handleGetJobWorkspaceColumnSavedViews();
        setCustomizeDropdownOpen(false);
      }
    } catch (error) {
      console.error("error in handleCreateSaveView", error);
      Toast(
        "error",
        error?.response?.data || "Failed to create customized columns",
      );
    }
  };

  const handleUpdateSaveView = async () => {
    try {
      if (!savedJobWorkspaceColumnViewId) {
        handleCreateSaveView();
        return;
      }

      const res = await patch(
        VYLABS_BASE_URL,
        `${UPDATE_SAVED_VIEWS}/${savedJobWorkspaceColumnViewId}`,
        { filters: getSelectedJobWorkspaceColumns() },
      );

      if (res?.view?.id) {
        Toast("success", "Updated Successfully!");
        setVisibleColumns(draftVisibleColumns);
        handleGetJobWorkspaceColumnSavedViews();
        setCustomizeDropdownOpen(false);
      }
    } catch (error) {
      console.error("error in handleUpdateSaveView", error);
      Toast(
        "error",
        error?.response?.data || "Failed to update customized columns",
      );
    }
  };

  return (
    <div style={{ padding: "24px" }}>
           {showTrialSnackbar && (
              <TrialSnackbar
                daysLeft={daysLeftInTrial}
                onClose={handleCloseSnackbar}
              />
            )}
      <div className="member-dashboard-header-main-container">
        <div className="hearder-inner-container">
          <div className="cephea-span-container">
            <h3 className="cephea-text">
              Hello, {userDetails?.first_name || "User"}!
            </h3>
            <img className="hello-icon" src={HelloIcon} alt="Hello" />
          </div>
          <div className="cephea-span-container">
            <h5 style={{ fontSize: 20, marginTop: 10, fontWeight: 400 }}>
              Welcome to VybogTAL, your recruitment companion
            </h5>
          </div>
        </div>
        <div className="member-dashboard-tenant-name">
          {tenantDetails?.logo_key ? (
            <div
              style={{
                width: "86px",
                height: "62px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                padding: "6px",
                boxSizing: "border-box",
              }}
            >
              <img
                alt="Tenant Logo"
                src={tenantDetails?.logo_key}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          ) : tenantFetchError ? (
            <h3 className="cephea-tentnt-text">Hi, this is VybogTAL!</h3>
          ) : (
            <h3 className="cephea-tentnt-text">{tenantDetails?.name}</h3>
          )}

          <div
            className="dashboard-notification-icon-container"
            onClick={toggleNotificationPopup}
            role="button"
            tabIndex={0}
            aria-label="Notifications"
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                toggleNotificationPopup(event);
              }
            }}
          >
            <img
              src={isDarkMode ? notificationDarkIcon : notificationIcon}
              alt="Notification"
              style={{ width: 30, height: 30 }}
            />
            {notificationUnreadCount > 0 && (
              <span className="dashboard-notification-badge">
                {notificationUnreadCount > 99 ? "99+" : notificationUnreadCount}
              </span>
            )}
          </div>
          {/* <Button
            iconSrc={isDarkMode ? filterDarkIcon : filterIcon}
            iconWidth="18px"
            backgroundColor="transparent"
            hoverd={false}
            border="1px solid var(--border__color)"
            style={{ borderRadius: "999px", padding: "5px" }}
            event={() => setIsStageFilterOpen(true)}
          /> */}
        </div>
      </div>
      <div className="member-dashboard-filter-panel">
        <div className="member-dashboard-filter-panel-top">
          <div className="member-dashboard-saved-view-actions">
            <DynamicAutocomplete
              options={savedViewOptions}
              value={activeSavedViewOption}
              onChange={handleSavedViewChange}
              placeholder="Select View"
              noOptionsText="No saved views found..."
              loading={isLoadingSavedViews}
              renderOption={(props, option) => {
                const { key, ...optionProps } = props;

                return (
                  <li {...optionProps} key={key}>
                    <span className="member-dashboard-saved-view-option-label">
                      {option.label}
                    </span>
                    <Button
                      type="button"
                      className="member-dashboard-saved-view-delete-button"
                      ariaLabel={`Delete ${option.label}`}
                      iconSrc={deleteIcon}
                      iconWidth="15px"
                      backgroundColor="transparent"
                      border="none"
                      hoverd={false}
                      style={{
                        width: "26px",
                        height: "26px",
                        minWidth: "26px",
                        marginLeft: "10px",
                        padding: 0,
                        borderRadius: "50%",
                      }}
                      onMouseDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                      }}
                      event={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setSavedViewPendingDelete(option);
                        setIsSavedViewDeleteDialogOpen(true);
                      }}
                    />
                  </li>
                );
              }}
              sx={{
                mt: "0",
                width: "240px",
                ".MuiOutlinedInput-root": {
                  borderRadius: "999px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid var(--border__color) !important",
                    borderRadius: "999px",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6860ee",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#7a70f2",
                  },
                },
                ".MuiInputBase-input": {
                  color: "var(--header__color)",
                  padding: "8px 12px !important",
                  height: "40px",
                  fontFamily: "Satoshi !important",
                },
              }}
              componentsProps={{
                popper: {
                  sx: {
                    "& .MuiAutocomplete-paper": {
                      backgroundColor: "var(--body__background)",
                      color: "var(--header__color)",
                      border: "1px solid var(--border__color)",
                      boxShadow: "0px 4px 20px rgba(0,0,0,0.18)",
                    },
                    "& .MuiAutocomplete-listbox": {
                      backgroundColor: "var(--body__background)",
                      color: "var(--header__color)",
                    },
                    "& .MuiAutocomplete-option": {
                      color: "var(--header__color)",
                      "&[aria-selected='true'], &.Mui-focused, &:hover": {
                        backgroundColor: "var(--filter-button)",
                      },
                    },
                    "& .MuiAutocomplete-noOptions": {
                      backgroundColor: "var(--body__background)",
                      color: "#6860ee",
                    },
                    "& .MuiAutocomplete-loading": {
                      backgroundColor: "var(--body__background)",
                      color: "#6860ee",
                      fontStyle: "italic",
                    },
                  },
                },
              }}
            />
            {isCreateViewButtonActive && (
              <Button
                label="Save View"
                event={handleCreateViewOpen}
                className="member-dashboard-save-filter-button"
                style={{
                  padding: "8px 15px",
                  whiteSpace: "nowrap",
                  minHeight: "40px",
                }}
                backgroundColor="#6860EE"
                color="#FFFFFF"
                border="none"
              />
            )}
          </div>
          <div className="member-dashboard-date-range-pill member-dashboard-date-range-pill-top">
            <CalendarDays size={20} strokeWidth={2} />
            <span>{memberDashboardDateRangeLabel}</span>
        </div>
      </div>
      <div className="member-dashboard-month-filter">
        <MonthFilter
          value={filters.time}
          options={DATE_FILTER_OPTIONS}
          onChange={(value) => {
            const newFilters = {
              ...filters,
              time: value,
            };

            setFilters(newFilters);
            refreshMemberDashboard(newFilters, searchText);
            getJobWorkspace(1, newFilters);
          }}
        />
        <DynamicAutocomplete
          placeholder="Search Jobs..."
          minCharsForSearch={0}
          options={jobListOptions}
          loading={jobOptionLoading}
          value={
            filters.jobId
              ? {
                  label: filters.jobTitle,
                  value: filters.jobId,
                }
              : null
          }
          onOpen={fetchInitialJobs}
          onInputChange={handleJobInputChange}
          onChange={(value) => {
            const newFilters = {
              ...filters,
              jobId: value?.value || "",
              jobTitle: value?.label || "",
            };

            setFilters(newFilters);
            refreshMemberDashboard(newFilters, searchText);
            getJobWorkspace(1, newFilters);
          }}
          sx={{
            mt: "0",
            width: "100%",
            ".MuiOutlinedInput-root": {
              borderRadius: "999px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid var(--border__color) !important",
                borderRadius: "999px",
                minheight: "auto",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#6860ee",
                borderRadius: "999px",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#7a70f2",
                borderRadius: "999px",
              },
            },
            ".MuiInputBase-input": {
              color: "var(--header__color)",
              padding: "8px 12px !important",
              height: "40px",
              fontFamily: "Satoshi !important",
            },
          }}
          slotProps={{
            paper: {
              sx: {
                backgroundColor: "var(--body__background)",
                color: "var(--header__color)",
                borderRadius: "12px",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                border: "1px solid var(--header__color)",
              },
            },
            listbox: {
              sx: {
                "& li": {
                  fontSize: "14px",
                  fontWeight: 500,
                  padding: "8px 16px",
                  color: "var(--header__color)",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.04)",
                  },
                },
              },
            },
          }}
        />
        <DynamicCallStage
          isMultiselect
          value={filters.stage}
          defaultOption="Select Stages"
          menuWidth={220}
          clearable
          wrapperStyle={{ width: "100%" }}
          onChange={(value) => {
            const newFilters = {
              ...filters,
              stage: value,
            };
            setFilters(newFilters);
            refreshMemberDashboard(newFilters, searchText);
            getJobWorkspace(1, newFilters);
          }}
          selectSx={{
            width: "100%",
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "999px !important",
            },
            "& .MuiSelect-select": {
              border: "1px solid transparent !important",
            },
          }}
        />
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "18px",
        }}
      >
        <DashboardCard
          title="PROFILES REVIEWED"
          value={dashboardSummary.profilesReviewed}
        />

        <DashboardCard title="CONTACTED" value={dashboardSummary.spoken} />

        <DashboardCard title="INTERESTED" value={dashboardSummary.interested} />

        <DashboardCard title="PROPOSED" value={dashboardSummary.proposed} />

        <DashboardCard title="INTERVIEWS" value={dashboardSummary.interviews} />

        <DashboardCard title="OFFERS" value={dashboardSummary.offers} />

        <DashboardCard title="FOLLOW-UPS" value={dashboardSummary.followUps} />

        <DashboardCard title="OVERDUE" value={dashboardSummary.overdue} />

        {isVendorFeatureEnabled && <DashboardCard title="VENDOR TRACKS" value={dashboardSummary.vendorTracks} />}

        <DashboardCard title="TRACKED" value={dashboardSummary.trackedCount} />
        
        <DashboardCard title="ASSIGNED" value={dashboardSummary.assignedCount} />
      </div>
      <div className="member-dashboard-table-content">
        <div className="member-dashboard-table-pipeline">
          <div className="member-dashboard-table-heading">
              <div>
                <h3>Candidate Workspace</h3>
                {candidateTotalRows > 0 && (
                  <span className="member-dashboard-candidate-total-rows">
                    {candidateTotalRows} Shown
                  </span>
                )}
              </div>
            {(candidateWorkspace.length > 0 || searchText.trim() !== "") && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "45%",
                }}
              >
                <label style={{whiteSpace: "nowrap"}}>Sort by</label>
                <DynamicSelectInput
                  defaultOption="Select"
                  options={candidateWorkspaceSortOptions}
                  value={selectedCandidateWorkspaceColumn}
                  onChange={(e) =>
                    setSelectedCandidateWorkspaceColumn(e.target.value)
                  }
                  labelKey="title"
                  selectStyle={{ width: "140px" }}
                />
                <img
                  src={
                    candidateWorkspaceSort?.sortOrder === "desc"
                      ? isDarkMode
                        ? sortDscDarkIcon
                        : sortDscLightIcon
                      : isDarkMode
                        ? sortAscDarkIcon
                        : sortAscLightIcon
                  }
                  alt={
                    candidateWorkspaceSort?.sortOrder === "desc"
                      ? "Sort descending"
                      : "Sort ascending"
                  }
                  onClick={handleCandidateWorkspaceSort}
                  style={{cursor: "pointer"}}
                />
              </div>
              <SimpleCepheaChat
                isDarkMode={isDarkMode}
                showExperienceAndLocation={false}
                showAttachResume={false}
                showJobDescriptionField={false}
                askMeAnythingValue={searchText}
                onAskChange={(e) => setSearchText(e.target.value)}
                onSubmit={handleSearch}
                onClearSimpleSearch={handleClearSearch}
                showCepheaActions={true}
                askmeanythingOnKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
                isHeaderNeeded={false}
                buttonLabel={<img src={SimpleSearchDarkIcon} alt="Search" />}
                clearButtonLabel="✖"
                askMeAnythingPlaceholder="Search Candidates"
              />
            </div>
            )}
          </div>
          <div style={{ width: "100%" }}>
            <Table
              columns={candidateWorkspaceColumns}
              data={candidateWorkspace}
              pagination
              paginationServer
              sortServer
              onSort={(column, sortDirection) => {
                const sortBy = column.sortField;
                if (!sortBy) return;

                const nextSort = {
                  sortBy,
                  sortOrder: sortDirection,
                };
                setCandidateWorkspaceSort(nextSort);
                setCandidateCurrentPage(1);
                getCandidateWorkspace(1, filters, searchText, nextSort);
              }}
              paginationTotalRows={candidateTotalRows}
              paginationPerPage={CANDIDATE_PAGE_SIZE}
              currentPage={candidateCurrentPage}
              onChangePage={(page) => {
                getCandidateWorkspace(page, filters, searchText);
              }}
              className="global-data-table member-dashboard-table-pipeline"
              dataNotFoundMessage="No Candidates Found"
              progressPending={candidateWorkspaceLoader}
              customNoDataFound={
                <div className="member-dashboard-fallbacks">
                  <img
                    src={isDarkMode ? NoCandidatesDark : NoCandidatesLight}
                    className="member-dashboard-fallback-img"
                    alt="No Data Found"
                  />
                  <span
                    style={{
                      color: "var(--text_color)",
                      fontSize: "19px",
                      fontWeight: "500",
                    }}
                  >
                    No candidates found
                  </span>
                  <span className="member-dashboard-fallback-text">
                    Try adjusting your filters or search to find
                  </span>
                </div>
              }
            />
          </div>
        </div>
      </div>
      <div className="member-dashboard-table-content" style={{ marginTop: "24px" }}>
        <div className="member-dashboard-table-pipeline">
          <div className="member-dashboard-table-heading">
            <div>
              <h3>Job Workspace</h3>
              {jobWorkspaceTotal > 0 && (
                <span className="member-dashboard-candidate-total-rows">
                  {jobWorkspaceTotal} Shown
                </span>
              )}
            </div>
            {jobWorkspace.length > 0 && (
            <div>
              <label style={{whiteSpace: "nowrap"}}>Tag</label>
              <DynamicSelectInput
                disableDefaultOption
                options={assignedOrTracked}
                value={selectedTagBasedFilter}
                onChange={(e) => setSelectedTagBasedFilter(e.target.value)}
                labelKey="title"
                selectStyle={{ width: "140px" }}
                clearable
              />
              <label style={{whiteSpace: "nowrap"}}>Sort by</label>
              <DynamicSelectInput
                defaultOption="Select"
                options={jobWorkspaceSortOptions}
                value={selectedJobWorkspaceColumn}
                onChange={(e) => setSelectedJobWorkspaceColumn(e.target.value)}
                labelKey="title"
                selectStyle={{ width: "140px" }}
              />
              <img
                src={jobWorkspaceSort.sortOrder === "desc" ?
                  isDarkMode ? sortDscDarkIcon : sortDscLightIcon
                  :
                  isDarkMode ? sortAscDarkIcon : sortAscLightIcon
                }
                alt="sortIcon"
                style={{ cursor: "pointer" }}
                onClick={handleJobWorkspaceSort}
              />
              <ColumnCustomizeDropdown
                  buttonRef={dropdownBtnRef}
                  columns={columnsForCustomize}
                  draftColumns={draftVisibleColumns}
                  dropdownRef={dropdownRef}
                  idPrefix="job-workspace-column"
                  isDarkMode={isDarkMode}
                  isOpen={customizeDropdownOpen}
                  hasSavedView={!!savedJobWorkspaceColumnViewId}
                  onCreateSaveView={handleCreateSaveView}
                  onSelectAll={handleSelectAll}
                  onSelectNone={handleSelectNone}
                  onToggleColumn={toggleColumnVisibility}
                  onToggleDropdown={toggleCustomizeDropdown}
                  onUpdateSaveView={handleUpdateSaveView}
                  />
            </div>
            )}
          </div>
          <div style={{ width: "100%" }}>
            <Table
              columns={jobWorkspaceColumns}
              data={jobWorkspace}
              pagination
              paginationServer
              paginationTotalRows={jobWorkspaceTotal}
              paginationPerPage={JOB_WORKSPACE_PAGE_SIZE}
              currentPage={jobWorkspaceCurrentPage}
              onChangePage={getJobWorkspace}
              className="global-data-table member-dashboard-table-pipeline"
              dataNotFoundMessage="No Jobs Found"
              progressPending={jobWorkspaceLoader}
              sortServer
              onSort={(column, direction) => {
                const sortBy = column.sortBy;
                if (!sortBy) return;
                const sort = {
                  sortBy,
                  sortOrder: direction
                }
                setJobWorkspaceSort(sort);
                setJobWorkspaceCurrentPage(1);
                getJobWorkspace(1, filters, sort);
              }}
              customNoDataFound={
                <div className="member-dashboard-fallbacks">
                  <img
                    src={isDarkMode ? NoCandidatesDark : NoCandidatesLight}
                    className="member-dashboard-fallback-img"
                    alt="No Data Found"
                  />
                  <span style={{ color: "var(--text_color)", fontSize: "19px", fontWeight: 500 }}>
                    No jobs found
                  </span>
                </div>
              }
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "24px",
          marginTop: "28px",
        }}
      >
        <div
          style={{
            border: "1px solid var(--card__border)",
            borderRadius: "18px",
            background: "var(--card__background)",
            padding: "22px",
            height: "350px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              fontSize: "22px",
              fontWeight: 700,
              marginBottom: "10px",
              flexShrink: 0,
            }}
          >
            Follow-ups
          </div>
          {followups?.today?.length === 0 &&
          followups?.overdue?.length === 0 &&
          followups?.tomorrow?.length === 0 &&
          !followUpsLoader ? (
            <div className="member-dashboard-fallbacks">
              <img
                src={isDarkMode ? NoFollowupDark : NoFollowupLight}
                className="member-dashboard-fallback-img"
                alt="No Data Found"
              />
              <span className="member-dashboard-fallback-text">
                Your pending follow-ups will appear here.
              </span>
            </div>
          ) : followUpsLoader ? (
            <VybogTALLoaderAnimation />
          ) : (
            <div
              style={{
                flex: 1,
                overflowY: "auto",
              }}
            >
              {renderSection("TODAY", "#5358EE", followups.today)}
              {renderSection("OVERDUE", "#EE343B", followups.overdue)}
              {renderSection(
                "TOMORROW",
                "var(--header__color)",
                followups.tomorrow,
              )}
            </div>
          )}
        </div>
        <div
          style={{
            border: "1px solid var(--card__border)",
            borderRadius: "18px",
            background: "var(--card__background)",
            padding: "22px 15px",
            height: "350px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "22px",
              flexShrink: 0,
            }}
          >
            <div
              style={{
                fontSize: "22px",
                fontWeight: 700,
              }}
            >
              Recent activity
            </div>
          </div>

          <div
            ref={recentActivityContainerRef}
            style={{
              flex: 1,
              overflowY: "auto",
            }}
          >
            {recentActivityLoader ? (
              <VybogTALLoaderAnimation />
            ) : recentActivity.length === 0 ? (
              <div className="member-dashboard-fallbacks">
                <img
                  src={isDarkMode ? NoActivityDark : NoActivityLight}
                  className="member-dashboard-fallback-img"
                  alt="No Data Found"
                />
                <span className="member-dashboard-fallback-text">
                  All your recent actions will show up here.
                </span>
              </div>
            ) : (
              <>
                {renderRecentActivity()}
                {recentActivityLoading && <VybogTALLoaderAnimation />}
              </>
            )}
          </div>
        </div>
      </div>
      {isNotificationPopupOpen && (
        <NotificationPopup
          isOpen={isNotificationPopupOpen}
          onClose={() => setIsNotificationPopupOpen(false)}
          notifications={notificationsState.notifications}
          unreadCount={notificationsState.unread_count}
          isDarkMode={isDarkMode}
        />
      )}
      <StandardPopup
        isOpen={viewOpen}
        onClose={handleCreateViewClose}
        onSubmit={createFilter}
        submitLabel="Save"
        isSubmitting={isCreatingSavedView}
        title="Save Dashboard View"
        width="700px"
        maxHeight="95vh"
        popupStyle={{
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TextInput
          label="View Name"
          name="savedViewName"
          value={savedViewName}
          onChange={(event) => setSavedViewName(event.target.value)}
          placeholder="Save Name"
          required
        />
        {(selectedJobName || selectedStageName) && (
          <div className="member-saved-view-filter-summary">
            {selectedJobName && (
              <div className="member-saved-view-filter-row">
                <span className="member-saved-view-filter-label">Job</span>
                <span className="member-saved-view-filter-badge">
                  {selectedJobName}
                </span>
              </div>
            )}
            {selectedStageName && (
              <div className="member-saved-view-filter-row">
                <span className="member-saved-view-filter-label">Stage</span>
                <div style={{display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "5px"}}>
                  {selectedStageName.map((i) => (
                    <span className="member-saved-view-filter-badge">
                      {i}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        <div className="member-saved-view-default">
          <div className="required-field-content">
            <h4>Default</h4>
            <p>Use this saved view as the default dashboard view</p>
          </div>

          <ToggleSwitcher
            name="savedViewIsDefault"
            value={savedViewIsDefault}
            onChange={(_, checked) => setSavedViewIsDefault(checked)}
          />
        </div>
      </StandardPopup>
      <ConfirmationPopup
        isOpen={isSavedViewDeleteDialogOpen}
        onClose={handleSavedViewDeleteClose}
        onConfirm={() => handleDeleteViews(savedViewPendingDelete?.value)}
        title="Delete Saved Filter?"
        subTitle="Confirmation required"
        message={
          <span>
            This will delete{" "}
            <span
              style={{
                color: "#6665ea",
                fontWeight: "bold",
              }}
            >
              "{applyEllipsis(savedViewPendingDelete?.label, 35)}"
            </span>
            . Are you sure you want to delete this saved filter?
          </span>
        }
        cancelLabel="No, Cancel"
        confirmLabel="Yes, Delete"
        confirmButtonClass="popup-button-danger"
        isSubmitting={isDeletingSavedView}
      />
      {/* <StageFilterPopup
        isOpen={isStageFilterOpen}
        onClose={() => setIsStageFilterOpen(false)}
        onApplyFull={handleFilterApply}
        showCandidateViewSelection={false}
        showDateFilter={true}
        showSelectJob={true}
        stages={allStages}
        initialFilters={[
          ...(filters.stage
            ? [
                {
                  type: "call_stage",
                  value: filters.stage,
                },
              ]
            : []),
          {
            type: "date",
            value: filters.time,
          },
          ...(filters.jobId
            ? [
                {
                  type: "job_id",
                  value: filters.jobId,
                  label: filters.jobTitle,
                },
              ]
            : []),
        ]}
      /> */}
      <SidePopup
        isOpen={isCandidatePopupOpen}
        onClose={closeCandidatePopup}
        sidePopupWidth="85%"
        contentPadding="0px"
        title="Candidate Details"
        showDeleteButton={false}
        headerRightComponent={
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              marginRight: "10px",
            }}
          >
            {isEditingCandidate ? (
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  label="Save"
                  event={saveCandidateChanges}
                  backgroundColor="#6860EE"
                  color="#FFFFFF"
                  border="none"
                  style={{ borderRadius: "12px" }}
                />
                <Button
                  label="Cancel"
                  event={resetCandidateEdit}
                  isCancel={true}
                  color="#000"
                  border="1px solid #ddd"
                  style={{ borderRadius: "12px", marginRight: "0px" }}
                />
              </div>
            ) : (
              <div style={{ display: "flex", gap: "20px", marginTop: "5px" }}>
                {!selectedCandidate?.isFileBased &&
                  (selectedCandidate?.email ||
                    selectedCandidate?.parsedResumeData?.BasicInfo?.Email) && (
                    <CustomTooltip title="Reach Out" arrow>
                      <img
                        src={ReachOutIcon}
                        alt="Reach Out"
                        onClick={() =>
                          candidateDetailsRef.current?.openReachOut()
                        }
                        style={{ width: "24px", cursor: "pointer" }}
                      />
                    </CustomTooltip>
                  )}
                {!selectedCandidate?.isFileBased && (
                  <CustomTooltip title="Edit Candidate" arrow>
                    <img
                      src={editIcon}
                      alt="Edit"
                      onClick={handleEditCandidate}
                      style={{ width: "22px", cursor: "pointer" }}
                    />
                  </CustomTooltip>
                )}
                {AdminAccess && (
                  <CustomTooltip title="Delete Candidate" arrow>
                    <img
                      src={deleteIcon}
                      alt="Delete"
                      onClick={handleOpenCandidateDeleteDialog}
                      style={{ width: "22px", cursor: "pointer" }}
                    />
                  </CustomTooltip>
                )}
              </div>
            )}
          </div>
        }
      >
        <div style={{ padding: "20px" }}>
          {candidateLoading ? (
            <div className="member-dashboard-view-candidate-loader">
              <VybogTALLoaderAnimation />
            </div>
          ) : (
            selectedCandidate && (
              <CandidateDetailsContainer
                ref={candidateDetailsRef}
                candidate={selectedCandidate}
                isEditingCandidate={isEditingCandidate}
                setIsEditingCandidate={setIsEditingCandidate}
                handleEditCandidate={handleEditCandidate}
                saveCandidateChanges={saveCandidateChanges}
                resetCandidateEdit={resetCandidateEdit}
                handleCandidateChange={handleCandidateChange}
                editedCandidateData={editedCandidateData}
                emailError={emailError}
                setEmailError={setEmailError}
                emailTouched={emailTouched}
                setEmailTouched={setEmailTouched}
              />
            )
          )}
        </div>
      </SidePopup>
      <ConfirmationPopup
        isOpen={isDeleteCandidatePopupOpen}
        onClose={() => setIsDeleteCandidatePopupOpen(false)}
        onConfirm={handleDeleteCandidate}
        title="Delete Candidate?"
        subTitle="Confirmation required"
        message={
          <span>
            You are about to delete{" "}
            <span
              style={{
                color: "#6665ea",
                fontWeight: "bold",
              }}
            >
              "{selectedCandidate?.name}"
            </span>
            .
            <br />
            <br />
            This action will permanently remove this candidate details,
            including any associations with jobs or vendors.
            <br />
            <br />
            This action cannot be undone. Are you sure you want to delete?
          </span>
        }
        cancelLabel="No, Cancel"
        confirmLabel="Yes, Delete"
        confirmButtonClass="popup-button-danger"
      />
    </div>
  );
}

export default MemberDashboard;